import {
  useCities,
  useCountries,
  useRegions,
  useSubcities,
  useWoredas,
  useZones
} from "features/members";
import { useMemo } from "react";

export const useAddressQueries = watch => {
  // Get watched values
  const countryId = watch("country_id");
  const regionId = watch("region_id");
  const zoneId = watch("zone_id");
  const cityId = watch("city_id");
  const subcityId = watch("sub_city_id");

  // Address queries
  const countriesQuery = useCountries();

  const regionsQuery = useRegions({
    countryId,
    config: {
      enabled: !!countryId
    }
  });

  const zonesQuery = useZones({
    regionId,
    config: {
      enabled: !!regionId
    }
  });

  const citiesQuery = useCities({
    zoneId,
    config: {
      enabled: !!zoneId
    }
  });

  const subcitiesQuery = useSubcities({
    cityId,
    config: {
      enabled: !!cityId
    }
  });

  const woredasQuery = useWoredas({
    subcityId,
    config: {
      enabled: !!subcityId
    }
  });

  // Memoized loading states
  const isLoading = useMemo(
    () =>
      countriesQuery.isLoading ||
      regionsQuery.isLoading ||
      zonesQuery.isLoading ||
      citiesQuery.isLoading ||
      subcitiesQuery.isLoading ||
      woredasQuery.isLoading,
    [
      countriesQuery.isLoading,
      regionsQuery.isLoading,
      zonesQuery.isLoading,
      citiesQuery.isLoading,
      subcitiesQuery.isLoading,
      woredasQuery.isLoading
    ]
  );

  return {
    countriesQuery,
    regionsQuery,
    zonesQuery,
    citiesQuery,
    subcitiesQuery,
    woredasQuery,
    isLoading
  };
};
